<div class="step-container">
  <div>
    <div class="d-lg-none text-center">
      <img src="assets/images/Logos/Compadres_Rewards.png" class="mobile-logo" />
    </div>
    <h4 class="text-center text-lg-left text-secondary">Partners</h4>
    <p class="text-center text-lg-left">
      Complete your partner registration by entering the partner code and secret code you received in the partner invitation
      email.
    </p>

    <fgbcl-errors></fgbcl-errors>
    <div class="mt-2 mt-lg-3 mb-5 mb-lg-4">
      <div class="row">
        <div class="col-12 col-lg-6">
          <label class="mb-2 font-weight-bold"> Partner Code </label>
          <input
            type="text"
            class="form-control bg-muted text-tertiary"
            placeholder="Insert code here"
            [(ngModel)]="partnerKeys.PartnerCode"
            name="PartnerCode"
            required
          />
        </div>
        <div class="col-12 col-lg-6">
          <label class="mb-2 font-weight-bold"> Partner Secret Code </label>
          <input
            type="text"
            class="form-control bg-muted text-tertiary"
            placeholder="Insert secret code here"
            [(ngModel)]="partnerKeys.PartnerSecretCode"
            name="PartnerSecretCode"
            required
          />
        </div>
      </div>
    </div>
  </div>
  <div class="button-container position-absolute">
    <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
  </div>
</div>
